import type { WebsiteHeaderPhotoSchema_PhotoBackgroundMonogram } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_BACKGROUND_MONOGRAM_DEFAULT: WebsiteHeaderPhotoSchema_PhotoBackgroundMonogram = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackgroundMonogram-v1_0_1.json',
  presentationLayout: 'photoBackgroundMonogram',
  photos: [],
  jsonContainerId: null,
  colors: undefined,
};
